import { useEffect, useState } from "react";

const toIt = (iso) => (iso ? iso.split("-").reverse().join("/") : "");
const mask = (raw) => {
  const d = raw.replace(/\D/g, "").slice(0, 8);
  return [d.slice(0, 2), d.slice(2, 4), d.slice(4)].filter(Boolean).join("/");
};
// "15/03/2027" -> "2027-03-15" if it is a real date, else null
const toIso = (txt) => {
  const m = txt.match(/^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/);
  if (!m) return null;
  const y = m[3].length === 2 ? 2000 + +m[3] : +m[3];
  const dt = new Date(y, +m[2] - 1, +m[1]);
  if (dt.getFullYear() !== y || dt.getMonth() !== +m[2] - 1 || dt.getDate() !== +m[1]) return null;
  return `${y}-${m[2]}-${m[1]}`;
};

// Date typed by hand as gg/mm/aaaa (slashes added automatically); emits ISO yyyy-mm-dd
export const DateInput = ({ value, onChange, className = "", placeholder = "gg/mm/aaaa", min, max, ...rest }) => {
  const [txt, setTxt] = useState(toIt(value));
  useEffect(() => { if (toIso(txt) !== (value || null)) setTxt(toIt(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const emit = (v) => { if (v !== (value || "")) onChange({ target: { value: v } }); };
  const change = (e) => {
    const t = mask(e.target.value);
    setTxt(t);
    setLeft(false);
    if (t.length === 10 && toIso(t)) emit(toIso(t));
    else emit("");
  };
  const [left, setLeft] = useState(false);
  const blur = () => {
    setLeft(true);
    const iso = toIso(txt);
    if (iso) { setTxt(toIt(iso)); emit(iso); }
  };
  const bad = !!txt && (txt.length === 10 || left) && !toIso(txt);
  return (
    <input type="text" inputMode="numeric" autoComplete="off" value={txt} onChange={change} onBlur={blur} placeholder={placeholder} maxLength={10}
      className={`flex h-10 rounded-md border px-3 text-sm bg-transparent outline-none focus:ring-2 focus:ring-white/30 ${/(^|\s)w-/.test(className) ? "" : "w-full"} ${bad ? "!border-[#E63946]" : ""} ${className}`}
      aria-invalid={bad || undefined} title={bad ? "Data non valida: usa gg/mm/aaaa" : undefined} {...rest} />
  );
};
